export default __webpack_public_path__ + "static/jira-product-discovery_attribution_dark-0dd5cb531667b7dca9419bcb8a5b1954.svg";